import api from "./api";

export const HelpdeskNotificationsAPI = {
  list: () => api("/helpdesk/admin/notifications"),
  listRecipientTypes: () => api("/helpdesk/admin/notifications/recipient-types"),
  listRoleOptions: () => api("/helpdesk/admin/rules/options/roles"),
  listUsers: () => api("/helpdesk/admin/users"),

  get: (id) => api(`/helpdesk/admin/notifications/${id}`),

  create: (data) =>
    api("/helpdesk/admin/notifications", {
      method: "POST",
      body: JSON.stringify(data),
    }),

  update: (id, data) =>
    api(`/helpdesk/admin/notifications/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
    }),
  listVariables: () => api("/helpdesk/admin/notifications/variables"),

  preview: (data) =>
  api("/helpdesk/admin/notifications/preview", {
    method: "POST",
    body: JSON.stringify(data),
  }),

  delete: (id) =>
  api(`/helpdesk/admin/notifications/${id}`, {
    method: "DELETE",
  }),
};